const initialState = {
    users: []
};
export const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_USERS':
            return {
                ...state,
                users: action.payload,
                loading: action.loading ?? false
            }
        default:
            return state;
    }
}
